import { IonIcon } from '@ionic/react';
import React from 'react';

import './Metric.css';

interface MetricProps {
  icon: string;
  label: string;
  value: React.ReactNode;
  barType: string;
  inView: boolean;
  direction?: 'left' | 'right';
}

const Metric: React.FC<MetricProps> = ({
  icon,
  label,
  value,
  barType,
  inView,
  direction = 'left'
}) => (
  <div className={`metric${inView ? ' inView' : ''} ${direction}`}>
    <div className="metricBar" data-metric-bar={barType}>
      <IonIcon icon={icon} className="metricIcon" />
      <p className="metricLabel">{label}</p>
    </div>
    <p className="metricValue">{value}</p>
  </div>
);

export default Metric;
